import { Modal, Form, Button, Row, Col } from 'react-bootstrap';
import { useState, useEffect } from 'react';

const EstimateTimeModal = ({
    show,
    onHide,
    initialValue = '0h 0m',
    onSubmit
}) => {
    const [hours, setHours] = useState('0');
    const [minutes, setMinutes] = useState('0');

    useEffect(() => {
        if (show) {
            // Parse initial value when modal opens
            const hoursMatch = initialValue.match(/(\d+)h/);
            const minutesMatch = initialValue.match(/(\d+)m/);
            
            setHours(hoursMatch ? hoursMatch[1] : '0');
            setMinutes(minutesMatch ? minutesMatch[1] : '0');
        }
    }, [show, initialValue]);

    const handleSubmit = (e) => {
        e.preventDefault();
        
        const h = parseInt(hours) || 0;
        const m = parseInt(minutes) || 0;

        // Convert to normalized format
        const totalMinutes = (h * 60) + m;
        const normalizedHours = Math.floor(totalMinutes / 60);
        const normalizedMinutes = totalMinutes % 60;

        let timeString = '';
        if (normalizedHours > 0) {
            timeString += `${normalizedHours}h`;
            if (normalizedMinutes > 0) {
                timeString += ` ${normalizedMinutes}m`;
            }
        } else if (normalizedMinutes > 0) {
            timeString = `${normalizedMinutes}m`;
        } else {
            timeString = '0h';
        }

        onSubmit(timeString);
        onHide();
    };

    const handleHoursChange = (e) => {
        const value = e.target.value;
        if (value === '' || /^\d+$/.test(value)) {
            setHours(value);
        }
    };

    const handleMinutesChange = (e) => {
        const value = e.target.value;
        if (value === '' || (/^\d+$/.test(value) && parseInt(value) <= 59)) {
            setMinutes(value);
        }
    };

    return (
        <Modal show={show} onHide={onHide} backdrop="static" keyboard={false} centered size="sm">
            <form onSubmit={handleSubmit}>
                <Modal.Header closeButton>
                    <Modal.Title className='display-1'>Estimate Time</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Row>
                        <Col>
                            <Form.Group>
                                <Form.Label>Hours</Form.Label>
                                <Form.Control
                                    type="text"
                                    value={hours}
                                    onChange={handleHoursChange}
                                    placeholder="0"
                                    className="text-center"
                                />
                            </Form.Group>
                        </Col>
                        <Col>
                            <Form.Group>
                                <Form.Label>Minutes</Form.Label>
                                <Form.Control
                                    type="text"
                                    value={minutes}
                                    onChange={handleMinutesChange}
                                    placeholder="0"
                                    className="text-center"
                                />
                            </Form.Group>
                        </Col>
                    </Row>
                    <div className="p-tag mt-2">Minutes cannot exceed 59</div>
                </Modal.Body>
                <Modal.Footer className='d-flex justify-content-between'>
                    <Button variant="link" className='text-danger text-decoration-none' onClick={onHide}>
                        Cancel
                    </Button>
                    <Button variant="primary" onClick={onHide}>
                        Save
                    </Button>
                </Modal.Footer>
            </form>
        </Modal>
    );
};

export default EstimateTimeModal;
